import { useState, useEffect, useLayoutEffect, useContext } from "react";
import { AppContext } from "../App";

export default function useDOP() {
  const { location } = useContext(AppContext);
  const [popupVisible, setPopupVisible] = useState(false);
  const [dop, setDop] = useState("October 2024");

  useLayoutEffect(() => {
    const hcpPopup = document.querySelector(".hcp-popup-header");

    if (hcpPopup) {
      setPopupVisible(true);
    } else {
      setPopupVisible(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (popupVisible) {
      setDop("September 2026");
    } else {
      switch (location.pathname) {
        case "/hcp/":
        case "/hcp":
        case "/hcp/initiating-fenhuma/":
        case "/hcp/initiating-fenhuma":
        case "/patient/useful-resources":
        case "/patient/why-have-i-been-prescribed-fenhuma":
        case "/patient/side-effects":
        case "/hcp/contact-us":
        case "/hcp/contact-us/":
          setDop("September 2026");
          break;
        case "/patient/taking-fenhuma":
        case "/patient":
        case "/patient/":
          setDop("October 2026");
          break;
        case "/hcp/pi":
          setDop("September 2025");
          break;
        case "/hcp/resources":
          setDop("October 2025");
          break;
        default:
          setDop("October 2024");
          break;
      }
    }
  }, [popupVisible, location.pathname]);

  return dop;
}
